import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Formik, Field } from 'formik';
import { Col, Form, Row, FormGroup, FormControl } from 'react-bootstrap';
// eslint-disable-next-line no-unused-vars
import { Modal, Select, Input, DatePicker, CustomDatePicker } from 'components';
import { useStore } from 'store';
import { fetchEventTypes } from 'store/actions/catalogs';
import { setGiftTableSearchValues } from 'store/actions/giftTable';
import { isThereEvenAValue } from 'util/validations';
import { useWindowSize } from 'hooks';
import { initialValues, schema } from './config';
// eslint-disable-next-line no-unused-vars
import  './styles.module.scss'

const TableSearchModal = ({ onClose, show }) => {
  const [state, dispatch] = useStore();
  const { catalogs, giftTable } = state;
  const { eventTypes = [] } = catalogs;
  const { giftTableSearchValues = {} } = giftTable;
  const [, { isMobile }] = useWindowSize();

  const history = useHistory();

  const handleSubmit = (values) => {
    if (!isThereEvenAValue(values)) return;

    dispatch(setGiftTableSearchValues(values));

    history.push('/buscar-evento');
  };

  useEffect(() => {
    dispatch(fetchEventTypes());
  }, []);

  return (
  <Formik
      initialValues={{ ...initialValues, ...giftTableSearchValues }}
      validationSchema={schema}
      onSubmit={handleSubmit}
  >
    {(formikProps) => (
        <Form onSubmit={formikProps.handleSubmit}>
          <Modal
              size="md"
              onSubmit={formikProps.handleSubmit}
              show={show}
              onClose={onClose}
              titleHeader="Buscar mesa"
              titleHeaderClassName="col-md-12 offset-md-1"
              subtitle="Puedes buscar la mesa de regalos con alguno de los siguientes datos."
              submitLabel="Buscar"
              variant="completed"
              variantOnlyInMobile
          >
            <Row>
              <Col xs={12} className="p-1">
                <FormGroup>
                  <Form.Label className="labels text-left">Festejado (a)</Form.Label>
                  <Input
                      name="eventName"
                      placeholder="Nombre del festejado"
                      maxLength={50}
                      className="inputBorder"
                  />
                </FormGroup>
                <FormGroup>
                  <Form.Label className="labels text-left">Número de evento</Form.Label>
                  <Input
                      type="text"
                      name="eventNumber"
                      inputMode="numeric"
                      pattern="\d*"
                      placeholder="Número de evento"
                      maxLength={10}
                      className="inputBorder"
                  />
                </FormGroup>
                {!isMobile ? (
                <FormGroup>
                  <Form.Label className="labels text-left">Fecha del Evento</Form.Label>
                  <DatePicker
                      name="eventDate"
                      placeholder=""
                      maxLength={50}
                      className="inputBorder"
                  />
                </FormGroup>
                ) : 
                (<Field name="eventDate" component={CustomDatePicker} label='Fecha del evento' maxLength={50} />)}
                

                <FormGroup>
                  <Form.Label className="labels text-left">Tipo de evento</Form.Label>
                  <Select
                      placeholder="Tipo de evento"
                      name="eventType"
                      options={eventTypes}
                  />
                </FormGroup>
              </Col>
            </Row>
          </Modal>
        </Form>
    )}
  </Formik>
);
};

export default TableSearchModal;
